export const Sentences = [
  ['一', '二', '三', '四', '五'],
  ['六', '七', '八', '九', '十'],
  ['人', '口'],
  ['眼', '睛'],
  ['耳', '朵'],
  ['嘴', '巴'],
  ['大', '小'],
  ['多', '少'],
  ['足', '球'],
  ['你', '好'],
  ['再', '见'],
  ['日', '月'],
  ['月', '亮'],
  ['山', '坡'],
  ['石', '头'],
  ['谢谢'],
  ['不', '客', '气'],
  ['老', '师', '好'],
  ['我', '是', '王', '小', '华'],
  ['他', '是', '我', '爸爸'],
  ['她', '是', '我', '妈妈'],
  ['我', '爱', '妈妈'],
  ['我', '爱', '爸爸', '妈妈'],
  ['爸爸', '是', '老师'],
  ['叔叔', '是', '警察'],
  ['妈妈', '是', '医生'],
  ['哥哥', '是', '学生'],
  ['请', '帮', '爸爸', '妈妈'],
  ['你', '叫', '什么', '名字'],
]

export function getRandomSentence() {
  let randomSentence = Sentences[Math.floor(Math.random() * Sentences.length)]
  return randomSentence
}
